import { useTranslator } from 'utils/translator';
import ErrorBoundary from './errorBoundary';

function ErrorBoundaryWrapper({ children }) {
  const { t } = useTranslator();

  return (
    <ErrorBoundary
      header={t('errorBoundaryHeader')}
      content={t('errorBoundaryContent')}
      buttonText={t('errorBoundaryButtonText')}
    >
      {children}
    </ErrorBoundary>
  );
}

export default ErrorBoundaryWrapper;
